/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserWalletListRespVo
 */
export interface UserWalletListRespVo {
    /**
     * 主键 ID
     * @type {number}
     * @memberof UserWalletListRespVo
     */
    id?: number;
    /**
     * 用户 ID，关联用户表主键
     * @type {number}
     * @memberof UserWalletListRespVo
     */
    userId?: number;
    /**
     * 用户名称
     * @type {string}
     * @memberof UserWalletListRespVo
     */
    userName?: string;
    /**
     * 用户账号
     * @type {string}
     * @memberof UserWalletListRespVo
     */
    userAccount?: string;
    /**
     * 钱包余额
     * @type {number}
     * @memberof UserWalletListRespVo
     */
    amount?: number;
    /**
     * 货币代码，如 CNY、USD、KRW 等
     * @type {string}
     * @memberof UserWalletListRespVo
     */
    currencyCode?: string;
    /**
     * 冻结金额
     * @type {number}
     * @memberof UserWalletListRespVo
     */
    freezeAmount?: number;
    /**
     * 是否可用：0-不可用，1-可用
     * @type {number}
     * @memberof UserWalletListRespVo
     */
    enable?: number;
    /**
     * 创建时间
     * @type {string}
     * @memberof UserWalletListRespVo
     */
    createTime?: string;
    /**
     * 修改时间
     * @type {string}
     * @memberof UserWalletListRespVo
     */
    updateTime?: string;
}

/**
 * Check if a given object implements the UserWalletListRespVo interface.
 */
export function instanceOfUserWalletListRespVo(value: object): value is UserWalletListRespVo {
    return true;
}

export function UserWalletListRespVoFromJSON(json: any): UserWalletListRespVo {
    return UserWalletListRespVoFromJSONTyped(json, false);
}

export function UserWalletListRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserWalletListRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'userAccount': json['userAccount'] == null ? undefined : json['userAccount'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'freezeAmount': json['freezeAmount'] == null ? undefined : json['freezeAmount'],
        'enable': json['enable'] == null ? undefined : json['enable'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
    };
}

export function UserWalletListRespVoToJSON(json: any): UserWalletListRespVo {
    return UserWalletListRespVoToJSONTyped(json, false);
}

export function UserWalletListRespVoToJSONTyped(value?: UserWalletListRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'userName': value['userName'],
        'userAccount': value['userAccount'],
        'amount': value['amount'],
        'currencyCode': value['currencyCode'],
        'freezeAmount': value['freezeAmount'],
        'enable': value['enable'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
    };
}

